import _ from 'lodash'
import TimeSlot from './time-slot'
import Range from '../models/range'
import Time from '../models/time'
import DayGroupings from '../options/day-groupings'
import DayOptions from '../options/day-options'
import HourOptions from '../options/hour-options'
import MinuteOptions from '../options/minute-options'

export default class {
    constructor(slots) {
        this.slots = this.compress(slots);
    }

    add(slot) {
        this.slots.push(slot);
    }

    addDefault() {
        const range = new Range(
            new Time(HourOptions[0], MinuteOptions[0]),
            new Time(HourOptions[24], MinuteOptions[0]),
        );

        this.add(new TimeSlot(DayOptions[0], range));
    }

    remove(slot) {
        this.slots = _.without(this.slots, slot);
    }

    isEmpty() {
        return _.isEmpty(this.slots);
    }

    sort() {
        const orderList = _.map(DayOptions, 'value');

        this.slots = _.sortBy(this.slots, (slot) => {
            return _.indexOf(orderList, slot.day.value);
        });
    }

    toArray() {
        return this.slots;
    }

    getExpanded() {
        return _.flatten(_.map(this.slots, (slot) => {
            return slot.isExpandable() ? slot.expand() : slot;
        }));
    }

    compress(slots) {
        for (const dayGrouping in DayGroupings) {
            slots = this.compressGroup(slots, dayGrouping, DayGroupings[dayGrouping]);
        }

        return slots;
    }

    compressGroup(slots, dayGrouping, dayGroupList) {
        let slotsWithinGroup = slots.filter((slot) => {
            return slot.day && _.includes(dayGroupList, slot.day.value);
        });

        let rangesWithinGroup = _.map(slotsWithinGroup, 'range');

        let groupSlots = [];

        rangesWithinGroup.forEach((range) => {
            let slotsThatMatchRange = _.filter(slotsWithinGroup, { range });

            let unqiueDays = _.uniqBy(slotsThatMatchRange, 'day');

            if (unqiueDays.length == dayGroupList.length) {
                slots = _.difference(slots, slotsThatMatchRange);
                slotsWithinGroup = _.difference(slotsWithinGroup, slotsThatMatchRange);

                const slot = new TimeSlot(_.find(DayOptions, { value: dayGrouping }), range);

                groupSlots.push(slot);
            }
        });

        return _.concat(groupSlots, slots);
    }

    isValid() {
        _.reduce(this.slots, (carry, slot) => carry && slot.isValid(), true);
    }
}
